export const notifierConstants = {
    ENQUEUE_NOTIFICATION: 'ENQUEUE_NOTIFICATION',
    CLEAR_ENQUEUE_NOTIFICATION: 'CLEAR_ENQUEUE_NOTIFICATION'
};